module.exports = __webpack_public_path__ + "img/read the store text.7e87e727.png";